import React from "react";
import styles from "./index.module.scss";
const Step = ({ icon, title, description, background, stepNumber, }) => {
    return (React.createElement("div", { className: `${styles.stepBorder} ${stepNumber === 2 ? styles.step2 : ""} ${stepNumber === 3 ? styles.step3 : ""}` },
        React.createElement("div", { className: styles.step, style: { background } },
            React.createElement("div", { className: styles.body },
                icon,
                React.createElement("div", { className: styles.text },
                    React.createElement("div", { className: styles.title }, title),
                    React.createElement("div", { className: styles.description }, description))))));
};
export default Step;
